export default "__VITE_ASSET__CDh7IGED__"